import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { cloud, ninja } from "@vitalsource/vstui/colors";
import { OffScreenComponent } from "../../../../components/mixins/index";
import { actions as uiLibraryActions } from "../../../../../redux/ui/library/index";
import { selectors as bridgeSelectors } from "../../../../../redux/bridge/index";
import Cover from "../../book/cover";
import {
  breakpointsPx,
  styledMedia
} from "../../../../components/mediaquery/breakpoints";
import { Translation } from "../../../../core/translate";

const COVER_WIDTH = 49;
const COVER_HEIGHT = 65;

const BookContainer = styled.li`
  padding: 0;
  margin: 0 0 15px;
  width: 100%;
  list-style-type: none;

  @media (max-width: ${breakpointsPx.medium}) and (min-width: ${breakpointsPx.small}) {
    &:last-child,
    &:nth-child(odd):nth-last-child(2) {
      button {
        border-bottom: none;
      }
    }
  }
`;

const BookButton = styled.button`
  background: none;
  border: 0;
  text-align: left;
  width: 100%;
  padding: 0 0 3px;

  ${styledMedia.medium`
    border-bottom: 1px solid ${cloud.getShade(4)};
    padding-bottom: 15px;
  `}
`;

const ItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

const CoverContainer = styled.div`
  border-radius: 4px;
  box-shadow: 0px 2px 1px 1px ${cloud.getShade(4)};
  height: ${COVER_HEIGHT}px;
  margin-right: 24px;
  overflow: hidden;

  ${styledMedia.medium`
    margin-right: 12px;
  `}
`;

const Details = styled.div`
  border-bottom: 1px solid ${cloud.getShade(4)};
  overflow: hidden;
  width: ${COVER_WIDTH}px;
  height: ${COVER_HEIGHT}px;
  padding-top: 5px;
  flex-grow: 1;

  ${styledMedia.medium`
    border-bottom: 0;
  `}
`;

const TextLine = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 1.8rem;
`;

const Title = styled(TextLine)`
  color: ${ninja.getShade(10)};
  font-weight: 400;
  padding-bottom: 2px;
`;

const Author = styled(TextLine)`
  color: ${cloud.getShade(7)};
  font-weight: 300;
`;

const TrendingBook = ({ title, author, isbn, openBookPanel }) => {
  return (
    <BookContainer>
      <BookButton onClick={() => openBookPanel(title)}>
        <ItemContainer>
          <CoverContainer>
            <Cover
              includeRetina={false}
              width={COVER_WIDTH}
              height={COVER_HEIGHT}
              isbn={isbn}
              altText={title}
              bookTitle={title}
            />
          </CoverContainer>
          <Details>
            <Title>{title}</Title>
            <Author>{author}</Author>
          </Details>
        </ItemContainer>
        <OffScreenComponent>
          <Translation id="explore.details" />
        </OffScreenComponent>
      </BookButton>
    </BookContainer>
  );
};

const mapLicenseStateToProps = (state, props) => ({
  ...bridgeSelectors.getAsset(state, props.isbn)
});

const mapDispatchToProps = (dispatch, props) => ({
  openBookPanel: title =>
    dispatch(uiLibraryActions.openSimpleBookPanel(props.isbn, title))
});

export default connect(
  mapLicenseStateToProps,
  mapDispatchToProps
)(TrendingBook);
